import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PageviewsettingsService } from '../services/pageviewsettings.service';
import { FormBuilder, FormGroup, Validators ,Form} from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import * as Globals from '../../globals';

@Component({
  selector: 'app-default-page',
  templateUrl: './default-page.component.html',
  styleUrls: ['./default-page.component.css']
})

export class DefaultPageComponent implements OnInit {
  currentSlide = 0;
  email: string = '';
  showSuccessMessage = false;
  images = Globals.DEFAULT_PAGE_BACKGROUND_IMAGES;
  currentIndex = 0;

 constructor(
       private router: Router,
       private route: ActivatedRoute,
       private settingsService: PageviewsettingsService,
       private titleService: Title,
       @Inject(DOCUMENT) private document: Document
      
 ){
  
 }
  ngOnInit(): void {
    const faviconUrl = Globals.DEFAULT_PAGE_FAVICON;
    const link: HTMLLinkElement | null = this.document.querySelector("link[rel*='icon']");
    
    if (link) {
      link.href = faviconUrl;
    }

    this.titleService.setTitle('Collegiate Mobile | Support Your University Just By Paying Your Phone Bill');

    this.showSuccessMessage=false
   setInterval(() => {
      this.currentIndex = (this.currentIndex + 1) % this.images.length;
    }, 5000);
     // 5s carousel interval
  
  }
resetSuccessMessage() {
  this.showSuccessMessage = false;
}
  



  callvisitoranalytics(){

    
   if (!this.email) return;
    this.settingsService.createvisitoranalytics('collegiatemobilelandingpage',this.email)
  .then(response => {
    console.log('visitors analytics endpoint called successfully', response);
    this.showSuccessMessage = true;
  })
  .catch(error => {
    console.error('Error calling endpoint', error);
    this.showSuccessMessage = false
  });
} 
  
}
